'use memo';

import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { AuthenticationHeader } from './_layout/-components/AuthenticationHeader';
export const Route = createFileRoute('/_staff/settings/authentication/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  const matchRoute = useMatchRoute();
  // 作成・編集ステッパーは親の ProductHeader（認証タイトル＋タブ）を出さない
  // （permission-and-roles / person/add と同様）。
  // ポリシー詳細も自前のパンくずヘッダーを持つため出さない（組織改編の詳細と同型）。
  const hideAuthenticationHeader = Boolean(matchRoute({
    to: '/settings/authentication/access-rules/new'
  })) || Boolean(matchRoute({
    to: '/settings/authentication/access-rules/$id'
  })) || Boolean(matchRoute({
    to: '/settings/authentication/policies/new'
  })) || Boolean(matchRoute({
    to: '/settings/authentication/policies/$id'
  })) || Boolean(matchRoute({
    to: '/settings/authentication/policies/$id/edit'
  }));

  // persons/_list と同型: flex-col + sticky=false。
  // ネストした overflow/h-full ラッパは背景の見え方を崩すため置かない。
  return <div className="flex flex-col">
      {!hideAuthenticationHeader ? <AuthenticationHeader sticky={false} /> : null}
      <Outlet />
    </div>;
}